<template>
   <div>
      <!-- 管理图标 -->
      <div class="sideBar_icon">
         <p>{{ company_name }}</p>
      </div>
      <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#1c2e43"
               text-color="#fff" active-text-color="#96fbc4" router :default-active="onRoutes">
         <template v-for="(item, index) in navMenu">
            <el-menu-item v-if="!item.childs" :index="item.path" :key="index">
               <img :src="item.img" style="width: 18px;height: 18px;margin-right: 5px;">
               <span slot="title">{{ item.title }}</span>
            </el-menu-item>

            <el-submenu v-if="item.childs" :index="item.path" :key="index">
               <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>{{ item.title }}</span>
               </template>
               <el-menu-item v-for="(value,i) in item.childs" :key="i" :index="value.path">
                  {{ value.title }}
               </el-menu-item>
            </el-submenu>
         </template>
      </el-menu>
   </div>
</template>

<script>
   export default {
      data() {
         return {
            company_name: '',
            path: "",
            navMenu: [],
            /*申报单位*/
            navList_01: [{
               title: "项目申报",
               img: require('../../assets/img/main/项目申报.png'),
               path: "/index/greenEngineerApply/projectList",
            }, {
               title: "绿色工程",
               img: require('../../assets/img/main/申报管理.png'),
               path: "/index/greenEngineerApply/applyList"
            }],
            /*推荐单位*/
            navList_02: [{
               title: "绿色工程",
               img: require('../../assets/img/main/申报管理.png'),
               path: "/index/greenEngineerRecom/applyList"
            }]
            /*
            {
               title: "申报管理",
               img: require('../../assets/img/main/项目申报.png'),
               path: "/index/greenEngineerRecom/projectList",
            },
            */
         }
      },
      created() {
         this.level()
      },
      watch: {},
      computed: {
         onRoutes() {
            const route = this.$route
            const {
               meta,
               path
            } = route
            if (meta.activeMenu) {
               return meta.activeMenu
            }
            return path
         },
      },
      methods: {
         level() {
            this.company_name = localStorage.getItem('company_name')
            //申报门户类型
            let portalType = localStorage.getItem('portalType')
            /*登录角色，0:申报企业,1:推荐单位*/
            let loginRoleId = localStorage.getItem('loginRoleId')

            //申报单位登录
            if (loginRoleId == 0) {
               this.navMenu = this.navList_01
               return;
            }
            //推荐单位
            if (loginRoleId == 1) {
               this.navMenu = this.navList_02
               return;
            }
         },
         handleClose() {

         },
         handleOpen() {

         },
      }
   }
</script>

<style>
   .sideBar_icon {
      width: 200px;
      height: 100px;
      line-height: 100px;
      color: #ffffff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
   }

   .sideBar_icon img {
      width: 30px;
      height: 30px;
      padding-left: 10px;
   }

   .sideBar_icon p {
      padding-left: 15px;
      padding-right: 15px;
      line-height: 30px;
   }
</style>
